window.app.directive("hmSwipeListitem", [
  "$animateCss",
  "$parse",
  "$timeout",
  "hmTouchEvents",
  function($animateCss, $parse, $timeout, defaultEvents) {
    return {
      restrict: "AE",
      scope: false,
      compile: function(element, attrs) {
        if (!isMobile) {
          return angular.noop;
        }

        element.addClass("hm-swipe-listitem");
        var triggerExpr = $parse(attrs.hmSwipeTrigger);
        var filterSwipe = attrs.hmSwipeFilter
          ? $parse(attrs.hmSwipeFilter)
          : function() {
              return false;
            };

        function findInheritedSwipe(element) {
          for (
            var hammer = element.inheritedData("hammer");
            hammer;
            hammer = angular
              .element(hammer.element.parentElement)
              .inheritedData("hammer")
          ) {
            var swipe = hammer.get("swipe");
            if (swipe) {
              return swipe;
            }
          }
        }

        return function(scope, element, attrs) {
          // panmove
          var target = attrs.hmSwipeListitem
            ? angular.element(element[0].querySelector(attrs.hmSwipeListitem))
            : element;

          var mc = element.data("hammer");
          var managerOpts = defaultEvents.extendWithDefaultManagerOpts(
            scope.$eval(attrs.hmManagerOptions)
          );

          // Check for a manager, make one if needed and destroy it when
          // the scope is destroyed
          if (!mc) {
            mc = new Hammer.Manager(element[0], managerOpts);
            element.data("hammer", mc);
            scope.$on("$destroy", function() {
              mc.destroy();
            });
          }

          mc.add(
            new Hammer.Pan({
              direction: Hammer.DIRECTION_HORIZONTAL,
              threshold: 20,
              pointers: 1
            })
          );

          var swipe = findInheritedSwipe(element.parent());

          mc.on("pan", onPanHorizontal);
          element.on("$destroy", function() {
            element.off();
            mc.off("pan", onPanHorizontal);
            if (swipe) {
              swipe.set({ enable: true });
              // swipe.dropRequireFailure(mc.get('pan'));
            }
          });

          var panActive;

          function onPanHorizontal(event) {
            var staticFilter =
              event.srcEvent.cancelable === false ||
              event.distance === 0 ||
              event.overallVelocityX === 0;

            // debugger

            if (target.hasClass("disable-swipe")) {
              return;
            }

            var translate = getTranslate(event.deltaX);
            if (
              staticFilter ||
              filterSwipe(scope, {
                direction: translate > 0 ? "right" : "left"
              })
            ) {
              target.css({
                transform: "translateX(0%)"
              });
              return;
            }
            target.css({
              transform: "translateX(" + translate + "px)"
            });
            if (swipe) {
              swipe.set({ enable: false });
            }

            var pan =
              event.deltaX > 0.0 ? "swipe-right-active" : "swipe-left-active";
            if (!panActive) {
              panActive = pan;
              element.addClass("swipe-active");
              element.addClass(panActive);
            } else if (panActive !== pan) {
              element.removeClass(panActive);
              panActive = pan;
              element.addClass(panActive);
            }

            if (event.isFinal) {
              console.debug("pan-release", event.deltaX, event.velocityX);

              var delta = getTranslate(event.deltaX);
              var duration, toValue;
              if (delta > 90 || delta + event.velocityX * 12 > 90) {
                console.debug("REJECT");
                toValue = 100;
                duration =
                  0.18 * (3.5 - Math.min(2, Math.abs(event.velocityX)));
              } else if (delta < -110 || delta + event.velocityX * 16 < -110) {
                console.debug("APPROVE");
                toValue = -100;
                duration =
                  0.18 * (3.5 - Math.min(2, Math.abs(event.velocityX)));
              } else {
                toValue = 0;
                duration = 0.18 * (1 + Math.abs(event.velocityX));
              }

              var from = {
                transform: "translateX(" + delta + "px)"
              };
              var to = {
                transform: "translateX(" + toValue + "%)"
              };

              console.warn(toValue, duration);
              $animateCss(target, {
                event: "move",
                duration: duration,
                easing: "ease-out",
                to: to,
                from: from
              })
                .start()
                .then(
                  function() {
                    target.css({
                      transform: "translateX(" + toValue + "%)"
                    });
                    if (swipe) {
                      swipe.set({ enable: true });
                    }

                    if (toValue !== 0) {
                      var res = triggerExpr(scope, {
                        dir: toValue > 0 ? "right" : "left",
                        target
                      });

                      element.addClass("swipe-trigger-active");
                      (res || $timeout(1500, false))
                        .then(function() {
                          element.addClass("swipe-trigger-complete");
                          // $timeout(0, false).then(function() {
                          //   panActive = undefined;
                          //   $animateCss(element, {
                          //     event: "leave",
                          //     duration: 0.6,
                          //     easing: "ease-out",
                          //     from: {
                          //       opacity: 0.8,
                          //       maxHeight: "90px"
                          //     },
                          //     to: {
                          //       opacity: 0,
                          //       maxHeight: "0"
                          //     }
                          //   })
                          //     .start()
                          //     .then(function() {
                          //       element.remove();
                          //       element.removeClass("swipe-active");
                          //       element.removeClass("swipe-trigger-active");
                          //       element.removeClass(panActive);
                          //     });
                          // });
                        })
                        .catch(function() {
                          element.removeClass("swipe-trigger-active");

                          $animateCss(target, {
                            event: "move",
                            duration: duration,
                            easing: "ease-out",
                            to: {
                              transform: "translateX(0%)"
                            },
                            from: to
                          })
                            .start()
                            .then(function() {
                              element.removeClass(panActive);
                              element.removeClass("swipe-active");
                              panActive = undefined;
                            });
                        });
                    } else {
                      element.removeClass("swipe-active");
                      element.removeClass(panActive);
                      panActive = undefined;
                    }
                  },
                  function() {
                    target.css({
                      transform: "translateX(" + toValue + "%)"
                    });
                    element.removeClass("swipe-active");
                    element.removeClass(panActive);
                    panActive = undefined;
                  }
                );
            }
          }

          function getTranslate(deltaX) {
            // var scale = deltaX > 0 ? 130 : 158;
            var scale = 320; //deltaX > 0 ? 280 : 280;
            var value = Math.tanh(deltaX / (1.03 * scale));
            return (
              scale * (value > 0 ? Math.min(value, 1) : Math.max(value, -1))
            );
          }
        };
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/hmSwipeListitem.js